import moment from "moment";
import React, { useEffect, useState, forwardRef } from "react";
import DatePicker from "react-datepicker";

const Expiration = ({ setStep, setExpirationData, expirationData }) => {
  const [time, setTime] = useState();
  const [date, setDate] = useState();
  const [isNew, setIsNew] = useState(true);
  const [week, setWeek] = useState("");

  useEffect(() => {
    if (expirationData) {
      setIsNew(false);
      setDate(expirationData.date);
      setTime(expirationData.time);
    }
  }, [expirationData]);

  const handlePrev = () => {
    if (date && time) {
      let obj = {
        date: date,
        time: time,
      };

      setExpirationData(obj);
    }

    setStep(1);
  };

  const handleNext = () => {
    setIsNew(false);

    if (date && time) {
      let obj = {
        date: date,
        time: time,
      };

      setExpirationData(obj);

      setStep(3);
    }
  };

  useEffect(() => {
    if (date && time) {
      let obj = {
        date: date,
        time: time,
      };

      setExpirationData(obj);
    }
  }, [date, time]);

  let getWeek = {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
  };

  useEffect(() => {
    if (date) {
      setWeek(getWeek[new Date(date).getDay()]);
    }
  }, [date]);

  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <>
      <input
        type="text"
        className="example-custom-input"
        onClick={onClick}
        ref={ref}
        value={
          week && value ? `${week}, ${moment(value).format("MMM DD")}` : ""
        }
      />
    </>
  ));

  const filterPassedTime = (time) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);

    return date &&
      moment([
        parseInt(moment(date).format("YYYY")),
        parseInt(moment(date).format("MM")) - 1,
        parseInt(moment(date).format("DD")),
      ]).diff(
        moment([
          parseInt(moment().format("YYYY")),
          parseInt(moment().format("MM")) - 1,
          parseInt(moment().format("DD")),
        ]),
        "days"
      ) > 0
      ? true
      : currentDate.getTime() < selectedDate.getTime();
  };

  return (
    <div className="event-list-cover typeofevent-row">
      <div className="title">
        <h3>Expiration</h3>
        <p>When will your deal expire?</p>
      </div>
      <div className="expiration-block">
        <div className="form-group date-input">
          <label>Date</label>
          <DatePicker
            selected={date}
            dropdownMode="select"
            autoComplete="off"
            onChange={(value) => {
              setDate(value);
              setTime(null);
            }}
            className="react-time-input"
            calendarClassName="react-time-picker"
            popperClassName="react-time-propper"
            minDate={new Date()}
            customInput={<ExampleCustomInput />}
          />
          <p hidden={!(!date && !isNew)} className="error-message">
            Date required
          </p>
        </div>
        <div className="form-group time-input">
          <label>Time</label>
          <DatePicker
            selected={time}
            dropdownMode="select"
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={30}
            dateFormat="h:mm aa"
            autoComplete="off"
            onChange={(value) => {
              setTime(value);
            }}
            filterTime={filterPassedTime}
            className="react-time-input"
            calendarClassName="react-time-picker"
            popperClassName="react-time-propper"
          />
          <p hidden={!(!time && !isNew)} className="error-message">
            Deal Time required
          </p>
        </div>
      </div>
      <div className="event-button-row submit">
        <button
          className="back-btn"
          onClick={() => {
            handlePrev();
          }}
        >
          Back
        </button>
        <button
          className="next-btn submit-btn"
          onClick={() => {
            handleNext();
          }}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Expiration;
